import React from 'react';
import { Task } from '../../types';
import { IndividualTaskItem } from './IndividualTaskItem';
import { CombinedTaskItem } from './CombinedTaskItem';

interface TaskItemProps {
  task: Task;
  onTaskAction?: (taskId: number | string) => void;
}

export const TaskItem: React.FC<TaskItemProps> = ({ task, onTaskAction }) => {
  // Проверяем, является ли задание комбинированным (квестом)
  const isCombinedTask = task.group === 'combined';

  console.log(`Task ${task.id} is ${isCombinedTask ? 'combined' : 'individual'} task`);

  // Выбираем компонент в зависимости от типа задания
  if (isCombinedTask) {
    return <CombinedTaskItem task={task} onTaskAction={onTaskAction} />;
  } else {
    return <IndividualTaskItem task={task} onTaskAction={onTaskAction} />;
  }
};
